import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { CONFIG_BUILD_ENV } from '@src/config/env'

import BUILD_PLATFORMS from '../constants/platformsTypes'
import { TEMPLATES, TemplateType } from '../constants/template-info'

interface IAppData {
  reviewImagesEndPoint: string
  environmentType: BUILD_ENVIRONMENTS
  buildPlatform: BUILD_PLATFORMS
  disableAllPlatformData: boolean
  buildAt: string
  commitHash: string
  releaseNumber: string
}

class AppData implements IAppData {
  readonly reviewImagesEndPoint: string
  readonly environmentType: BUILD_ENVIRONMENTS
  readonly buildPlatform: BUILD_PLATFORMS
  readonly disableAllPlatformData: boolean
  readonly shouldHaveMobileData: boolean
  readonly shouldHaveDesktopData: boolean
  readonly buildAt: string
  readonly commitHash: string
  readonly releaseNumber: string
  private templateType: TemplateType

  constructor({
    reviewImagesEndPoint,
    environmentType,
    buildPlatform,
    disableAllPlatformData,
    commitHash,
    buildAt,
    releaseNumber,
  }: IAppData) {
    this.reviewImagesEndPoint = reviewImagesEndPoint
    this.environmentType = environmentType
    this.buildPlatform = buildPlatform
    this.disableAllPlatformData = disableAllPlatformData
    this.shouldHaveMobileData = disableAllPlatformData || buildPlatform === BUILD_PLATFORMS.MOBILE
    this.shouldHaveDesktopData = disableAllPlatformData || buildPlatform === BUILD_PLATFORMS.DESKTOP
    this.buildAt = buildAt
    this.commitHash = commitHash
    this.releaseNumber = releaseNumber
    this.templateType = TEMPLATES.UNKNOWN
  }

  getTemplateType() {
    return this.templateType || TEMPLATES.UNKNOWN
  }

  setTemplateType(templateType: TemplateType) {
    return (this.templateType = templateType)
  }
}

// TODO-SSR: Make APP Data
const appData = new AppData({
  reviewImagesEndPoint: 'https://cdn.stamped.io/uploads/photos',
  environmentType: CONFIG_BUILD_ENV,
  disableAllPlatformData: true,
  buildPlatform: BUILD_PLATFORMS.DESKTOP,
  buildAt: 'NA',
  commitHash: 'NA',
  releaseNumber: 'NA',
})

export default appData
